/* eslint-disable */
/**
 * Resolve taks in sequence
 *
 * @param  {array}      tasks
 * @param  {function}   fn
 * @return {promise}
 */
export const sequence = (tasks, fn, skipError = false) => {
  return tasks.reduce(
    (promise, task) => promise
      .then(() => fn(task))
      .catch((err) => skipError ? Promise.resolve() : err),
    Promise.resolve()
  )
}
